/* eslint-disable */
/*
 * ----------------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API-ES            ##
 * ## SOURCE: https://github.com/hunghg255/swagger-typescript-api-es   ##
 * ----------------------------------------------------------------------
 */

export interface ApiProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ApiValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors: Record<string, string[]>;
  [key: string]: any;
}

/** Данные сертификата */
export interface ApiHostCertificateData {
  /** Имя */
  name: string;
  /** Имя центра сертификации */
  issuer: string;
  /** Псевдоним */
  friendlyName: string;
  /** Серийный номер */
  serialNumber: string;
  /** Алгоритм подписи */
  signatureAlgorithm: string;
  /** Отпечаток */
  thumbprint: string;
  /** Имя субъекта из сертификата */
  subject: string;
  /** Атрибуты субъекта по имени */
  subjectAttributesByName: Record<string, string>;
  /** Атрибуты субъекта по OID */
  subjectAttributesByOid: Record<string, string>;
  /** Атрибуты центра сертификации по имени */
  issuerAttributesByName: Record<string, string>;
  /** Атрибуты центра сертификации по OID */
  issuerAttributesByOid: Record<string, string>;
  /**
   * Дата в формате местного времени, после которой сертификат недействителен
   * @format date-time
   */
  notAfter: string;
  /**
   * Дата в формате местного времени, после которой сертификат становится действительным
   * @format date-time
   */
  notBefore: string;
  /** Версия формата сертификата X.509 */
  version: string;
  /** Сертификат */
  certificate: string;
}

/** Мета-данные файла */
export interface ApiHostFileMeta {
  /**
   * Идентификатор файла
   * @format uuid
   */
  id: string;
  /** Имя файла */
  name: string;
  /** mime тип файла */
  mimeType: string;
  /**
   * Пространство имен файла (namespace), например: requests/master-account-request/trust,
   * requests/master-account-request/inn
   */
  namespace?: string | null;
  /** Данные ЭЦП файла */
  signatures?: ApiHostFileSignature[] | null;
}

/** Подпись файла */
export interface ApiHostFileSignature {
  /**
   * Данные ЭЦП
   * @format byte
   */
  signature: string;
  /** Данные сертификата подписи */
  certificates: ApiHostCertificateData[];
  /**
   * Дата создания подписи
   * @format date-time
   */
  createdAt: string;
}

export interface ApiFileCreatePayload {
  /**
   * Данные файла
   * @format binary
   */
  data: File;
  /** Имя файла */
  name: string;
  /**
   * Пространство имен файла (namespace), например: requests/master-account-request/trust,
   * requests/master-account-request/inn, аналог directory path в файловой системе
   */
  namespace: string;
  /** mime тип файла */
  mimeType: string;
}

export interface ApiSignedCreatePayload {
  /**
   * Данные подписи
   * @format binary
   */
  signature: File;
  /**
   * Данные файла
   * @format binary
   */
  data: File;
  /** Имя файла */
  name: string;
  /**
   * Пространство имен файла (namespace), например: requests/master-account-request/trust,
   * requests/master-account-request/inn, аналог directory path в файловой системе
   */
  namespace: string;
  /** mime тип файла */
  mimeType: string;
}

export interface ApiSignCreateByIdPayload {
  /**
   * Данные подписи
   * @format binary
   */
  signature: File;
}

export interface ApiSignatureListByIdParams {
  /** Имя подписанного файла, на основе которого формируется архив */
  fileName?: string;
  /** Идентификатор при печати */
  fileIdentifier?: string;
  /**
   * Идентификатор файла
   * @format uuid
   */
  id: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;

  abortService?: {
    getSignal(): AbortSignal;
  };
  instance?: AxiosInstance;
  injectHeaders?: (data: any) => any;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;
  private injectHeaders?: (data: any) => any;
  private abortService: {
    getSignal(): AbortSignal;
  };

  constructor({
    securityWorker,
    secure,
    format,
    instance,
    injectHeaders,
    abortService,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance =
      instance ?? axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
    this.injectHeaders = injectHeaders;
    this.abortService = abortService!;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T, _E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    let headers = {
      ...(requestParams.headers || {}),
      ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
    };

    if (this.injectHeaders) {
      headers = await this.injectHeaders(headers);
    }

    return this.instance.request({
      ...requestParams,
      headers,
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
      signal: this.abortService.getSignal(),
    });
  };
}

/**
 * @title File Storage Api
 * @version v1
 * @license
 * @contact File Storage Api
 *
 * File Storage Api
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  file = {
    /**
     * No description
     *
     * @tags File
     * @name FileCreate
     * @summary Загрузка файла
     * @request POST:/file
     */
    fileCreate: (data: ApiFileCreatePayload, params: RequestParams = {}) =>
      this.request<ApiHostFileMeta, ApiValidationProblemDetails>({
        path: `/file`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name SignedCreate
     * @summary Загрузка файла с подписью
     * @request POST:/file/signed
     */
    signedCreate: (data: ApiSignedCreatePayload, params: RequestParams = {}) =>
      this.request<ApiHostFileMeta, ApiValidationProblemDetails>({
        path: `/file/signed`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name MetaListById
     * @summary Возвращает мета-данные файла
     * @request GET:/file/{id}/meta
     * @secure
     */
    metaListById: (id: string, params: RequestParams = {}) =>
      this.request<ApiHostFileMeta, void | ApiProblemDetails>({
        path: `/file/${id}/meta`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name DataListById
     * @summary Возвращает данные файла
     * @request GET:/file/{id}/data
     * @secure
     */
    dataListById: (id: string, params: RequestParams = {}) =>
      this.request<void, void | ApiProblemDetails>({
        path: `/file/${id}/data`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name PreviewListById
     * @summary Возвращает PDF для предварительного просмотра файла
     * @request GET:/file/{id}/preview
     * @secure
     */
    previewListById: (id: string, params: RequestParams = {}) =>
      this.request<void, void | ApiProblemDetails>({
        path: `/file/${id}/preview`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name SignCreateById
     * @summary Подпись файла
     * @request POST:/file/{id}/sign
     */
    signCreateById: (id: string, data: ApiSignCreateByIdPayload, params: RequestParams = {}) =>
      this.request<ApiHostFileMeta, ApiValidationProblemDetails>({
        path: `/file/${id}/sign`,
        method: 'POST',
        body: data,
        type: ContentType.FormData,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name SignatureListById
     * @summary Возвращает zip-архив файла с подписями файла по его идентификатору
     * @request GET:/file/{id}/signature
     * @secure
     */
    signatureListById: ({ id, ...query }: ApiSignatureListByIdParams, params: RequestParams = {}) =>
      this.request<void, void | ApiProblemDetails>({
        path: `/file/${id}/signature`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),
  };
}
